import { useState, useEffect } from 'react';
import DisasterService, { DisasterEvent } from '../services/disasterService';

export const useAllDisasters = (refreshInterval: number = 300000) => {
  const [disasters, setDisasters] = useState<DisasterEvent[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [lastUpdated, setLastUpdated] = useState<Date | null>(null);

  useEffect(() => {
    const fetchDisasters = async () => {
      try {
        setLoading(true);
        const data = await DisasterService.getAllDisasters();
        setDisasters(data);
        setLastUpdated(new Date());
        setError(null);
      } catch (err) {
        setError('Failed to fetch disaster data');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchDisasters();
    const interval = setInterval(fetchDisasters, refreshInterval);
    return () => clearInterval(interval);
  }, [refreshInterval]);

  return { disasters, loading, error, lastUpdated };
};